import { BicycleParkingSpotInfo } from "./BicycleParkingSpotInfo";

export default BicycleParkingSpotInfo